// extracted by css-extract-rspack-plugin
export default {"Flash":"PlanSupportBanner-module__Flash__erbiDh5","Box":"PlanSupportBanner-module__Box__oW6UCne","Text":"PlanSupportBanner-module__Text__Znezs4v"};